var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Situation"},[(_vm.item.situation !== '')?[_c('span',{staticClass:"bluelinkNotInderlined",on:{"click":_vm.show}},[_vm._v("Подробнее")])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }